import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-jaldee-homeo',
  templateUrl: './jaldee-homeo.component.html',
  styleUrls: ['./jaldee-homeo.component.css']
})
export class JadeeHomeoComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_status;
  statusTo: string;
  disableConfirmbtn = false;
  changeStatus;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    const data = {
      'channelIds': [1,2,3]

    };
    this.accountService.changeJaldeeHomeo(this.data.id, 'ENABLE_CHANNEL' ,data)
    .subscribe(
      data => {
        this.api_success = 'Added Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}
